import { render, staticRenderFns } from "./CardHolder.vue?vue&type=template&id=6c6110b6&scoped=true&"
import script from "./CardHolder.vue?vue&type=script&lang=js&"
export * from "./CardHolder.vue?vue&type=script&lang=js&"
import style0 from "./CardHolder.vue?vue&type=style&index=0&id=6c6110b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6110b6",
  null
  
)

export default component.exports